import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import ButtonCommonComponent from "../common/ButtonCommonComponent";
import DisplaySelectedOptionsList from "../common/DisplaySelectedOptionsList";
import TextAreaField from "../common/TextAreaField";
import LinkBorderCommonButton from "../common/LinkBorderCommonButton";
import { clientDashboard, clientdPreviewRequirement } from "../common/allLinks";

const optionsSkill = [
  { value: "Skill Name 1", label: "Skill Name 1" },
  { value: "Skill Name 2", label: "Skill Name 2" },
  { value: "Skill Name 3", label: "Skill Name 3" },
  { value: "Skill Name 4", label: "Skill Name 4" },
  { value: "Skill Name 5", label: "Skill Name 5" },
  { value: "Skill Name 6", label: "Skill Name 6" },
];

const optionsEducationLevel = [
  { value: "Graduate", label: "Graduate" },
  { value: "Master Graduate", label: "Master Graduate" },
];

const optionsExperienceLevel = [
  { value: "3 Years", label: "3 Years" },
  { value: "4 Years", label: "4 Years" },
];

export default function ClientDashboardAddNewRequirementAddResourceDetails() {
  const [values, setValues] = useState({
    selectedValSkill: "",
    displayListSelected: [],
    selectedEducationlevel: "",
    selectedMinYearOfExperience: "",
    expectation: "",
  });

  const navigate = useNavigate();

  /*===========================================
                handleOnChange
===========================================*/
  const handleOnChange = (e) => {
    setValues({
      ...values,
      [e.target.name]: e.target.value,
    });
    // console.log(values);
  };

  const handleChangeDropdownSkill = (selectedOption) => {
    let newList = values.displayListSelected;
    if (newList.indexOf(selectedOption) === -1) {
      newList.push(selectedOption);
      setValues({
        ...values,
        selectedValSkill: selectedOption,
        displayListSelected: newList,
      });
    } else {
      setValues({
        ...values,
        selectedValSkill: selectedOption,
      });
    }
  };

  const handleRemoveMember = (index) => (e) => {
    let newList = values.displayListSelected;
    newList.splice(index, 1);
    setValues({
      ...values,
      displayListSelected: newList,
      selectedValSkill: "",
    });
  };

  const handleChangeMinEducationLevel = (selectedOption) => {
    setValues({ ...values, selectedEducationlevel: selectedOption });
  };

  const handleChangeMinYearOfExperienceLevel = (selectedOption) => {
    setValues({ ...values, selectedMinYearOfExperience: selectedOption });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // console.log(values);
    navigate({ pathname: clientdPreviewRequirement });
  };

  return (
    <div className="cdanr-add-resource-details-div">
      <div className="row mx-0 align-items-start flex-md-nowrap">
        <div className="col-12 col-md-6">
          <div>
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              Minimum Education Level
            </p>
            <div className="react-select-agency-dashboard-first-time">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={optionsEducationLevel}
                value={values.handleChangeMinEducationLevel}
                onChange={handleChangeMinEducationLevel}
                placeholder="Select"
              />
              {/* display error */}
            </div>
          </div>
          <div className="pt-35">
            <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
              Min. Years of Experience
            </p>
            <div className="react-select-agency-dashboard-first-time">
              <Select
                className="react-select-container"
                classNamePrefix="react-select-elements"
                isSearchable={false}
                options={optionsExperienceLevel}
                value={values.selectedMinYearOfExperience}
                onChange={handleChangeMinYearOfExperienceLevel}
                placeholder="Select"
              />
              {/* display error */}
            </div>
          </div>
          <TextAreaField
            containerClassName="pt-35 cdanr-add-resource-details-textarea"
            label="Expectations from the resource"
            placeholder="for ex. Roles &amp; Responsibilities"
            onChange={handleOnChange}
            name="expectation"
            value={values.expectation}
          />
        </div>
        <div className="col-12 col-md-6">
          <p className="font-14-NunitoSans-600 mt-agency-dashboard-label">
            Key SKills Required
          </p>
          <div className="react-select-agency-dashboard-first-time">
            <Select
              className="react-select-container"
              classNamePrefix="react-select-elements"
              isSearchable={false}
              options={optionsSkill}
              value={values.selectedValSkill}
              onChange={handleChangeDropdownSkill}
              placeholder="Select"
            />
            {/* display error */}
          </div>
          <h5 className="font-14-NunitoSans-600 custom-d-flex justify-content-between cdanr-add-resource-details-selected-skill-text">
            Selected Skills <span>*Max 15 Allowed</span>
          </h5>
          <DisplaySelectedOptionsList
            displayListSelected={values.displayListSelected}
            handleRemoveMember={handleRemoveMember}
          />
        </div>
      </div>
      <div className="text-center mt-100 mobile-d-flex">
        <LinkBorderCommonButton
          linkPath={clientDashboard}
          linkText="Save &amp; Exit"
          extraClassName="login-btn-link--preview mr-30"
        />
        <ButtonCommonComponent
          extraClassName="login-btn--px-45"
          text="Save &amp; Preview"
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
}
